import React  from 'react'
import styled from 'styled-components'
import { Link } from 'react-router'

import { flex, colors } from '../styles'
import { FrontEnd, Center } from './Title'
import TopRight from './TopRight'

const Outer = styled.div`
  height: 3.5rem;
  background: ${ colors.darkBackground };
  padding: 0 1rem;
  ${ flex.centerBoth }
`

const Logo = styled(Link)`
  margin-right: auto;
  text-decoration: none;
  display: block;
  > ${ Center } {
    margin-left: 1rem;
    font-size: 1rem;
  }
`

const BannerNav = ({right}) => (
  <Outer>
    <Logo to="/">
      <FrontEnd/>
      <Center/>
    </Logo>
    { right || <TopRight/>}
  </Outer>
)

export default BannerNav



/** WEBPACK FOOTER **
 ** ./src/components/BannerNav.js
 **/